import { useTranslation } from 'react-i18next';

import { LabeledInput } from '@work4all/components/lib/input/labeled-input';

import { ControllerPlus } from '../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../form-plus/use-form-context-plus';
import { Collapse, ControlWrapper } from '../../../components';
import { WebShopMaskFormValue } from '../types';

export const WebShopOverlayControllerAccessData = () => {
  const { t } = useTranslation();
  const { control } = useFormContextPlus<WebShopMaskFormValue>();

  return (
    <Collapse title={t('COMMON.ACCESS_DATA')} defaultOpen>
      <ControlWrapper columns={4}>
        <ControllerPlus
          control={control}
          name="userName"
          render={({ field }) => {
            return <LabeledInput {...field} label={t('COMMON.USERNAME')} />;
          }}
        />

        <ControllerPlus
          control={control}
          name="password"
          render={({ field }) => {
            return (
              <LabeledInput
                {...field}
                type="password"
                autoComplete="new-password"
                label={t('COMMON.PASSWORD')}
              />
            );
          }}
        />
      </ControlWrapper>
    </Collapse>
  );
};
